/**
 * Adapter functions for bridging Atomic CRM's jsonb email/phone format
 * with MYLES's simple string format used by import and scoring.
 */

/** Extract primary email from Atomic CRM's email_jsonb format */
export function getPrimaryEmail(emailJsonb: any): string | null {
    if (!emailJsonb || !Array.isArray(emailJsonb)) return null;
    const work = emailJsonb.find((e: any) => e.type === 'work');
    return work?.email || emailJsonb[0]?.email || null;
}

/** Extract primary phone from Atomic CRM's phone_jsonb format */
export function getPrimaryPhone(phoneJsonb: any): string | null {
    if (!phoneJsonb || !Array.isArray(phoneJsonb)) return null;
    const work = phoneJsonb.find((p: any) => p.type === 'work');
    return work?.number || phoneJsonb[0]?.number || null;
}

/** Convert simple email string to Atomic CRM jsonb format */
export function toEmailJsonb(email: string): Array<{ email: string; type: string }> {
    if (!email) return [];
    return [{ email, type: 'work' }];
}

/** Convert simple phone string to Atomic CRM jsonb format */
export function toPhoneJsonb(phone: string): Array<{ number: string; type: string }> {
    if (!phone) return [];
    return [{ number: phone, type: 'work' }];
}
